/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-04 18:41:01
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-03-11 14:20:29
 * @FilePath: /unifyxp-v2-store-portal/src/config/routerConfig/salesChannelVersion/salesChannelVersion.ts
 */
/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import {
  DirectDiscountEdit,
  DirectDiscountList,
  FlashSaleEdit,
  FlashSaleList,
  GiftPurchaseEdit,
  GiftPurchaseList,
  PromotionTagDetail,
  PromotionTagList,
  SalesChannelCheckout,
  SalesChannelCollectionEditor,
  SalesChannelCollectionList,
  SalesChannelCommunication,
  SalesChannelCommunicationTemplate,
  SalesChannelCookies,
  SalesChannelCurrency,
  SalesChannelDigitalMarketing,
  SalesChannelDomainEdit,
  SalesChannelDomainList,
  SalesChannelEditorMaintenancePage,
  SalesChannelInventory,
  SalesChannelInvoice,
  SalesChannelLanguage,
  SalesChannelLegalPageEditor,
  SalesChannelLegalPageList,
  SalesChannelLocalisation,
  SalesChannelLogistics,
  SalesChannelLogoManagement,
  SalesChannelMiniProgramSetting,
  SalesChannelOrder,
  SalesChannelPageCategory,
  SalesChannelPayment,
  SalesChannelProductCategory,
  SalesChannelRegistration,
  SalesChannelSettings,
  SalesChannelTax,
  SalesChannelTCPageEditor,
  SalesChannelTermsAndConditionList,
  SubscriptionBuyEdit,
  SubscriptionBuyList,
  VoucherDetail,
  VoucherList,
} from '@/src/pages';
import {
  SalesChannelVersionContent,
  SalesChannelVersionProducts,
} from 'src/pages/SalesCannelVersion';
import {
  communicationPage,
  taxPage,
  miniProgramPage,
  domainPage,
  logoPage,
  registrationPage,
  checkoutPage,
  paymentPage,
  cookiesPage,
  orderPage,
  languagePage,
  inventoryPage,
  localisationPage,
  logisticsPage,
  currencyPage,
  digitalMarketPage,
  invoicePage,
  discountDetailPage,
  discountListPage,
  tcDetailPage,
  tcListPage,
  legalDetailPage,
  legalListPage,
  collectionPage,
  categoryPage,
  maintenancePage,
  promotionTagDetailPage,
  promotionTagListPage,
  //productDetailPage,
  productListPage,
  //contentDetailPage,
  contentListPage,
  settingPage,
} from 'src/tools/permissions/salesChannelPermissions';
import { EPermissionSource } from 'src/types/common/resources';
import { salesChannelRoutes } from 'src/tools/urlMap';

const listRoutes = [
  {
    exact: true,
    path: salesChannelRoutes.contentList, // '/salesChannel/content/:uuid',
    component: SalesChannelVersionContent,
    isPrivate: true,
    permissionGroupGenerate: contentListPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: salesChannelRoutes.productList, // '/salesChannel/products/:uuid',
    component: SalesChannelVersionProducts,
    isPrivate: true,
    permissionGroupGenerate: productListPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: salesChannelRoutes.legalPageDetail, //'/salesChannel/legalPage/editor/:uuid/:legalPageUuid',
    component: SalesChannelLegalPageEditor,
    isPrivate: true,
    permissionGroupGenerate: legalDetailPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: salesChannelRoutes.tcDetail, // '/salesChannel/termsAndCondition/editor/:uuid/:TcUuid',
    component: SalesChannelTCPageEditor,
    isPrivate: true,
    permissionGroupGenerate: tcDetailPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: salesChannelRoutes.legalPageList, //'/salesChannel/legalPage/list/:uuid',
    component: SalesChannelLegalPageList,
    isPrivate: true,
    permissionGroupGenerate: legalListPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: salesChannelRoutes.settings, //'/salesChannel/settings/:uuid',
    component: SalesChannelSettings,
    isPrivate: true,
    permissionGroupGenerate: settingPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: salesChannelRoutes.tcList, //'/salesChannel/termsAndCondition/list/:uuid',
    component: SalesChannelTermsAndConditionList,
    isPrivate: true,
    permissionGroupGenerate: tcListPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: salesChannelRoutes.categoryProducts, //'/salesChannel/category/products/:uuid',
    component: SalesChannelProductCategory,
    isPrivate: true,
    permissionGroupGenerate: categoryPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    path: salesChannelRoutes.collectionList, //'/salesChannel/collections/list/:uuid',
    component: SalesChannelCollectionList,
    isPrivate: true,
    permissionGroupGenerate: collectionPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.collectionDetail, //'/salesChannel/collections/editor/:uuid/:collectionsUuid',
    component: SalesChannelCollectionEditor,
    isPrivate: true,
    permissionGroupGenerate: collectionPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.categoryPages, //'/salesChannel/category/pages/:uuid',
    component: SalesChannelPageCategory,
    isPrivate: true,
    permissionGroupGenerate: categoryPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.flashSalesList, //'/salesChannel/discounts/flashSale/list/:uuid',
    component: FlashSaleList,
    isPrivate: true,
    permissionGroupGenerate: discountListPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.flashSalesDetail, // '/salesChannel/discounts/flashSale/editor/:uuid/:discountUuid',
    component: FlashSaleEdit,
    isPrivate: true,
    permissionGroupGenerate: discountDetailPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.invoiceSetting, // '/salesChannel/setting/invoice/:uuid',
    component: SalesChannelInvoice,
    isPrivate: true,
    permissionGroupGenerate: invoicePage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.digitalMarketingSetting, // '/salesChannel/setting/digitalmarketing/:uuid',
    component: SalesChannelDigitalMarketing,
    isPrivate: true,
    permissionGroupGenerate: digitalMarketPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: salesChannelRoutes.currencySetting, //'/salesChannel/setting/currency/:uuid',
    component: SalesChannelCurrency,
    isPrivate: true,
    permissionGroupGenerate: currencyPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.logisticsSetting, //'/salesChannel/setting/logistics/:uuid',
    component: SalesChannelLogistics,
    isPrivate: true,
    permissionGroupGenerate: logisticsPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.localisationSetting, //'/salesChannel/setting/localisation/:uuid',
    component: SalesChannelLocalisation,
    isPrivate: true,
    permissionGroupGenerate: localisationPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.inventorySetting, //'/salesChannel/setting/inventory/:uuid',
    component: SalesChannelInventory,
    isPrivate: true,
    permissionGroupGenerate: inventoryPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: salesChannelRoutes.languageSetting, //'/salesChannel/setting/language/:uuid',
    component: SalesChannelLanguage,
    isPrivate: true,
    permissionGroupGenerate: languagePage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.orderSetting, //'/salesChannel/setting/order/:uuid',
    component: SalesChannelOrder,
    isPrivate: true,
    permissionGroupGenerate: orderPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.cookieSetting, //'/salesChannel/setting/cookies/:uuid',
    component: SalesChannelCookies,
    isPrivate: true,
    permissionGroupGenerate: cookiesPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: salesChannelRoutes.paymentSetting, //'/salesChannel/setting/payment/:uuid',
    component: SalesChannelPayment,
    isPrivate: true,
    permissionGroupGenerate: paymentPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.checkoutSetting, //'/salesChannel/setting/checkout/:uuid',
    component: SalesChannelCheckout,
    isPrivate: true,
    permissionGroupGenerate: checkoutPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: salesChannelRoutes.registrationSetting, //'/salesChannel/setting/registration/:uuid',
    component: SalesChannelRegistration,
    isPrivate: true,
    permissionGroupGenerate: registrationPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: salesChannelRoutes.maintenance, //'/salesChannel/maintenance/:uuid',
    component: SalesChannelEditorMaintenancePage,
    isPrivate: true,
    permissionGroupGenerate: maintenancePage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.logoManagementSetting, //'/salesChannel/setting/logoManagement/:uuid',
    component: SalesChannelLogoManagement,
    isPrivate: true,
    permissionGroupGenerate: logoPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.domainSetting, //'/salesChannel/setting/domain/:uuid',
    component: SalesChannelDomainList,
    isPrivate: true,
    permissionGroupGenerate: domainPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.domainDetailSetting, //'/salesChannel/setting/domain/:uuid/:domainUuid',
    component: SalesChannelDomainEdit,
    isPrivate: true,
    permissionGroupGenerate: domainPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.taxSetting, //'/salesChannel/setting/tax/:uuid',
    component: SalesChannelTax,
    isPrivate: true,
    permissionGroupGenerate: taxPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.directDiscountDetail, // '/salesChannel/discounts/directDiscount/editor/:uuid/:discountUuid',
    component: DirectDiscountEdit,
    isPrivate: true,
    permissionGroupGenerate: discountDetailPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.directDiscountList, //'/salesChannel/discounts/directDiscount/list/:uuid/',
    component: DirectDiscountList,
    isPrivate: true,
    permissionGroupGenerate: discountListPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.subscriptionBuyDetail, // '/salesChannel/discounts/subscriptionBuy/editor/:uuid/:discountUuid',
    component: SubscriptionBuyEdit,
    isPrivate: true,
    permissionGroupGenerate: discountDetailPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.subscriptionBuyList, //'/salesChannel/discounts/subscriptionBuy/list/:uuid/',
    component: SubscriptionBuyList,
    isPrivate: true,
    permissionGroupGenerate: discountListPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    isPrivate: true,
    permissionGroupGenerate: discountDetailPage,
    source: EPermissionSource.salesChannel,
    path: salesChannelRoutes.giftPurchaseDetail, //'/salesChannel/discounts/giftPurchase/editor/:uuid/:discountUuid',
    component: GiftPurchaseEdit,
  },
  {
    exact: true,
    path: salesChannelRoutes.giftPurchaseList, // '/salesChannel/discounts/giftPurchase/list/:uuid/',
    component: GiftPurchaseList,
    isPrivate: true,
    permissionGroupGenerate: discountListPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.voucherList, //'/salesChannel/discounts/voucher/list/:uuid/',
    component: VoucherList,
    isPrivate: true,
    permissionGroupGenerate: discountListPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.voucherDetail, //'/salesChannel/discounts/voucher/editor/:uuid/:discountUuid',
    component: VoucherDetail,
    isPrivate: true,
    permissionGroupGenerate: discountDetailPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.promotionTagList, //'/salesChannel/promotionTagList/:uuid/',
    component: PromotionTagList,
    isPrivate: true,
    permissionGroupGenerate: promotionTagListPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.promotionTagDetail, //'/salesChannel/promotionTag/editor/:uuid/:tagUuid',
    component: PromotionTagDetail,
    isPrivate: true,
    permissionGroupGenerate: promotionTagDetailPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.miniProgramSetting, //'/salesChannel/setting/miniProgramSetting/:uuid',
    component: SalesChannelMiniProgramSetting,
    isPrivate: true,
    permissionGroupGenerate: miniProgramPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.communicationSetting, //'/salesChannel/setting/communication/:uuid',
    component: SalesChannelCommunication,
    isPrivate: true,
    permissionGroupGenerate: communicationPage,
    source: EPermissionSource.salesChannel,
  },
  {
    exact: true,
    path: salesChannelRoutes.communicationTemplate, //'/salesChannel/setting/communication/template/:uuid/:communicationUuid/:category',
    component: SalesChannelCommunicationTemplate,
    isPrivate: true,
    permissionGroupGenerate: communicationPage,
    source: EPermissionSource.salesChannel,
  },
];
// const {

// }=permissionGenerate(uuid);

//uuid=salesChannelUuid

export default listRoutes;
